import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  img {
    overflow: visible;
    max-width: 100%;
  }
`
export const TrainingSize_Desktop = ({
  annotations,
}: {
  annotations?: React.ReactNode[]
}) => {
  return (
    <Wrapper>
      <img src={require('./trainingsize_desktop.png')} />
      {annotations &&
        annotations.map((anno) => {
          return <>{anno}</>
        })}
    </Wrapper>
  )
}
